import { Consulate } from './consulate';
import { EndedMunicipality } from './ended-municipality';
import { FlagBoolean } from './flag-boolean';
import { Province } from './province';
import { Region } from './region';
import { ForeignState } from './state';
import { Territory } from './territory';

type Key = {
  codice?: string;
};

export enum FlagMunicipality {
  Active = '',
  Void = 'A',
  Ended = 'C',
  NewDescription = 'D',
  NotSuitable = 'N',
  Edited = 'V',
}

type TerritoryConsulate = {
  territorio?: Territory;
  consolato?: Consulate;
  key?: {
    codiceConsolato?: string;
    codiceTerritorio?: string;
  };
};

export type MunicipalityConsulate = {
  territorioConsolato?: TerritoryConsulate;
  codiceTerritorio?: string;
  codiceConsolato?: string;
};

export interface Municipality {
  cap?: string;
  consolato?: Consulate;
  capoluogo?: FlagBoolean;
  className?: string;
  codFiscale?: string;
  codIstat?: string;
  dataIstituz?: string;
  data?: string;
  flag?: FlagMunicipality;
  oldCode?: string;
  provincia?: string;
  provinciaVO?: Province;
  statoEsteroVO?: ForeignState;
  comuneCessato?: [EndedMunicipality];
  comuneTerritorioConsolato?: MunicipalityConsulate;
  regione?: string;
  regioneVO?: Region;
  tribunale?: number;
  nome?: string;
  key?: Key;
  codConsolato?: number;
  codTerritorio?: number;
}
